class AccordionProduct {
  constructor(containerSelector, btnSelector) {
    this.container = document.querySelector(containerSelector);
    this.btnSelector = document.querySelector(btnSelector);
    this.dynamicPrice = this.btnSelector.querySelectorAll('.dynamic-price');
    
    if (!this.container) {
      console.error("Accordion container not found!");
      return;
    }
    this.init();
  }

  init() {
    this.radioButtons = this.container.querySelectorAll('input[type="radio"][name="b1g1_selector"]');
    this.bindEvents();
    this.updateAllDynamicPrices();
  }

  bindEvents() {
    this.radioButtons.forEach((radio) => {
      radio.addEventListener("change", (event) => this.onRadioChange(event));
    });
  }

  onRadioChange(event) {
    const selectedRadio = event.target;
    const selectedValue = selectedRadio.value; 
    const selectedId = selectedRadio.id;
    const accordions = this.container.querySelectorAll(".accordion-col");

    accordions.forEach((accordion) => {
      const variantPicker = accordion.querySelector(".product_info_container");
      const radio = accordion.querySelector(`input[type="radio"]`);

      if (radio.id === selectedId) {
        variantPicker.style.display = "block";
        accordion.classList.add('open-option');
      } else {
        variantPicker.style.display = "none";
        accordion.classList.remove('open-option');
      }
    });

    if (this.dynamicPrices) {
      this.dynamicPrices.forEach((priceElement, index) => {
        if (index === Array.from(this.radioButtons).indexOf(selectedRadio)) {
          priceElement.textContent = selectedValue;
        }
      });
    }

    this.formButtonChecker(selectedId);
  }

  updateAllDynamicPrices() {
    if (this.dynamicPrice) {
      this.radioButtons.forEach((radio, index) => {
        if (this.dynamicPrice[index]) {
          this.dynamicPrice[index].textContent = radio.value;
        }
      });
    }
  }

  formButtonChecker(selectedId){
    console.log(selectedId);
    if(selectedId == "b1g1_unchecked"){
      document.querySelector("#b1g1_not_form").style.display = "block";
      document.querySelector("#b1g1_form").style.display = "none";
    }else{
      document.querySelector("#b1g1_not_form").style.display = "none";
      document.querySelector("#b1g1_form").style.display = "block";
    }
  }
}

// Instantiate the Accordion class

new AccordionProduct(".default-banner-accord", ".variant_tabs");



document.addEventListener('variant:change', function(event) {
  new AccordionProduct(".default-banner-accord", ".variant_tabs");
  
  let target = event.target; // The element that triggered the event
  let form = target.closest("form"); // Find the closest parent form
  let formId = form.attributes.id.nodeValue;
  let public_title = event.detail.variant.public_title;
  let variant_price = (event.detail.variant.price / 100).toFixed(2);
  

  if (formId === "b1g1_top" || formId === "b1g1") {
    const discountPercent = Number(window.custom_discount_setup) || 0;

    const var_picker = document.querySelector(`[form-id="${formId}"]`);

    // Base prices from DOM (data-price is assumed cents)
    const topInput = document.querySelector(`form#b1g1_top input[name="id"]`);
    const regInput = document.querySelector(`form#b1g1 input[name="id"]`);

    let b1g1_top_price = topInput ? Number(topInput.dataset.price) / 100 : 0; // dollars (number)
    let b1g1_price = regInput ? Number(regInput.dataset.price) / 100 : 0;     // dollars (number)

    // variant_price is assumed dollars already (e.g. "129.00" or 129)
    const currentVariantPrice = Number(variant_price) || 0;

    // Override whichever form triggered the change
    if (formId === "b1g1_top") {
      b1g1_top_price = currentVariantPrice;
      topInput.dataset.price = currentVariantPrice * 100;
    } else {
      b1g1_price = currentVariantPrice;
      regInput.dataset.price = currentVariantPrice * 100;
    }

    // Apply discount to the lesser price
    const lowerPrice = Math.min(b1g1_top_price, b1g1_price);
    const higherPrice = Math.max(b1g1_top_price, b1g1_price);

    const discountedLower = lowerPrice * (1 - discountPercent / 100);
    const total = higherPrice + discountedLower;

    // Update title + total
    if (var_picker) {
      const titleEl = var_picker.querySelector(".variant-picker__option-info span");
      if (titleEl) titleEl.textContent = public_title;
    }

    document.querySelector(
      ".default-banner-accord .sale-container .discounted-price .money"
    ).textContent = `$${total.toFixed(2)}`;
    document.querySelector(`form#b1g1_top .discounted-price .money`).textContent = `$${total.toFixed(2)}`
    document.querySelector(`form#b1g1 .discounted-price .money`).textContent = `$${total.toFixed(2)}`
  } else {
    const price = Number(variant_price);
    const discountPercent = Number(window.custom_discount_setup) || 0;
    const discountedPrice = price * (1 - discountPercent / 100);
    const total = price + discountedPrice;
    document.querySelector(".default-banner-accord .sale-container .discounted-price .money").textContent = `$${total.toFixed(2)}`;
    document.querySelector(`form#b1g1_top input[name="id"]`).dataset.price = price * 100;
    document.querySelector(`form#b1g1 input[name="id"]`).dataset.price = price * 100;
    document.querySelector(`form#b1g1_top .discounted-price .money`).textContent = `$${total.toFixed(2)}`
    document.querySelector(`form#b1g1 .discounted-price .money`).textContent = `$${total.toFixed(2)}`
  }
});


